import { EmbeddedDisplayUntil } from 'modules/domains/campaign';
import { SearchQueryValidationErrors } from 'modules/journey/components/RuleBuilder';
import { IS_SET, IS_NOT_SET } from 'utils/comparatorTypes';

/**
 * Get the validation errors for a search query
 */
export const getQueryErrors = (
  searchQuery: EmbeddedDisplayUntil['searchQuery'],
): SearchQueryValidationErrors => {
  if (!searchQuery) return {};
  // @ts-ignore
  const { value, field, comparatorType } = searchQuery?.searchQueries?.[0] || {
    field: '',
    value: '',
    comparatorType: '',
  };

  return {
    ...(comparatorType ? {} : { comparatorType: { validationError: true } }),
    ...(field ? {} : { field: { validationError: true } }),
    // value can be empty for IS_SET and IS_NOT_SET
    ...(value || [IS_SET, IS_NOT_SET].includes(comparatorType)
      ? {}
      : { value: { validationError: true } }),
  };
};
